<template>
  <VWidget
    v-if="order.shipping.method"
    :title="$t('Payment Method')"
    class="mb-4"
  >
    <v-layout
      slot="widget-content"
      row
      wrap
    >
      <v-flex xs12>
        <v-radio-group
          v-model="order.payment"
        >
          <v-radio
            v-for="method in methods"
            :key="method.code"
            :label="`${method.name}`"
            :value="method.code"
          />
        </v-radio-group>
      </v-flex>
    </v-layout>
  </VWidget>
</template>

<script>

export default {
  name: 'OrderDraftPayments',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      methods: []
    }
  },

  async mounted () {
    const paymentMethods = await this.$http.paymentMethods.get()
    this.methods = paymentMethods.filter(m => m.isOffline())
  }
}
</script>
